import readyTypes from './readyTypes'

export const getReady = payload => ({
  type: readyTypes.GET_READY,
  payload
})

export const getReadySuccess = payload => ({
  type: readyTypes.GET_READY_SUCCESS,
  payload
})

export const getReadyFailure = payload => ({
  type: readyTypes.GET_READY_FAILURE,
  payload
})

export const clearReady = () => ({
  type: readyTypes.CLEAR_READY
})

export const setFilters = payload => ({
  type: readyTypes.SET_FILTERS,
  payload
})

export const searchByMovementNumber = payload => ({
  type: readyTypes.SEARCH_BY_MOVEMENT_NUMBER,
  payload
})

export const loadMore = payload => ({
  type: readyTypes.LOAD_MORE,
  payload
})
